import React from 'react';
import styles from './styles.module.scss';
import icError from 'assets/img/ic_error_v2.png';
import Button from 'src/Components/Button_V2';
import PopupModal from 'src/Components/PopupModal_V2';

const ErrorModal = ({
  onClose,
  message,
  buttonTitle,
  onSubmit
}) => {
  return /*#__PURE__*/React.createElement(PopupModal, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("img", {
    src: icError
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "OOPS!"), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, message), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.btn,
    title: buttonTitle,
    type: "primary",
    onClick: onSubmit
  }))));
};

export default ErrorModal;